// extracted by mini-css-extract-plugin
export var buttonContent = "_45-0";
export var centered = "_45-1";
export var centeredFlex = "_45-2";
export var errorText = "_45-3";
export var icon = "_45-4";
export var iconButtonContent = "_45-5";
export var monospace = "_45-6";
export var padded = "_45-7";